export enum SearchDataType {
  Text = 'text',
  Integer = 'integer',
  Double = 'double',
  Boolean = 'boolean',
  Date = 'date',
  Codelist = 'codelist',
  User = 'user',
  Picklist = 'picklist',
  Largetext = 'largetext',
}
